export default __webpack_public_path__ + "static/youtube-4151dcdf85b41a94803a12dc975c1b85.svg";